export default "__VITE_ASSET__gfh3wfww__"